var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderBox',{attrs:{"index":"2"}}),_vm._v(" "),_c('div',{staticClass:"split"}),_vm._v(" "),_c('section',[_c('article',{staticClass:"fl"},[_c('JottingList',{attrs:{"title":"心随笔动"}})],1),_vm._v(" "),_c('AsideBox')],1),_vm._v(" "),_c('FooterBox')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0be7298","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/JottingView.vue
// module id = null
// module chunks = 